<template>
  <div>
    <v-text-field
      id="physical_event_commission_percentage"
      :label="$t('Physical event commission percentage (%)')"
      name="physical_event_commission_percentage"
      type="text"
      :rules="[rules.inBetween(0, 100, company.physical_event_commission_percentage)]"
      v-model="company.physical_event_commission_percentage"
      color="saPrimary"
    >
      <template v-slot:append>
        <v-tooltip top color="white">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-information-outline</v-icon>
          </template>
         <div class="greyDarken3--text body-1">
            {{ $t('admin.physical.event.setting.tooltip') }}
          </div>
        </v-tooltip>
      </template>
    </v-text-field>
    <!-- Booking Revenue calculation time in hours -->
    <v-text-field
      v-model="company.custom_properties.booking_revenue_calculation_time"
      color="saPrimary"
      :label="
        $t('screener.admin.company.registration.booking_revenue_calculation_time')
      "
      :rules="[
        rules.required,
        rules.numeric,
        rules.inBetween(
          48,
          72,
          company.custom_properties.booking_revenue_calculation_time
        ),
      ]"
    >
      <template v-slot:append>
        <v-tooltip top color="white">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-information-outline</v-icon>
          </template>
          <span
            class="greyDarken3--text body-1"
            v-html="
              $t(
                'screener.admin.company.registration.booking_revenue_calculation_time.tooltip'
              )
            "
          ></span>
        </v-tooltip>
      </template>
    </v-text-field>
  </div>
</template>

<script>
import i18n from "@/i18n";
import rules from "@/validation";
import DEFINES from "@/defines";

export default {
  name: "AdminCompanyProfilePhysicalEventSetting",
  props: {
    company: {
      type: Object,
      default: null,
    },
  },
  data() {
    return { rules };
  },
  watch: {
    company: {
      handler: function () {
        this.$emit("update:company", this.company);
      },
      deep: true,
    },
  },
};
</script>

<style>
</style>
